import homeRouter from './home/home'
import unprocessedRouter from './home/unprocessed'
import urgentUnprocessedRouter from './home/urgentUnprocessed'
import atUnprocessedRouter from './home/atUnprocessed'
import projectSearchRouter from './home/projectSearch'
import carrierSearchRouter from './home/carrierSearch';
import companySearchRouter from './home/company_search';
import joinCompany from './joinCompany/joinCompany'
import waitingToSee from './waitingToSee/waitingToSee'
import replyMe from './replyMe/replyMe'

const indexRouter = {
    path: 'index',
    name: 'index',
    meta: {
        title: '首页'
    },
    redirect: {
        name: 'home'
    },
    component: () => import('@/components/router/Router'),
    children:[
        homeRouter,
        joinCompany,
        waitingToSee,
        unprocessedRouter,
        urgentUnprocessedRouter,
        replyMe,
        atUnprocessedRouter,
        projectSearchRouter,
        carrierSearchRouter,
        companySearchRouter
    ]
};
export default indexRouter;


// WEBPACK FOOTER //
// ./src/router/index/indexRouter.js